export const referenceId = value => value && String(typeof value === 'object' ? value._id || '' : value).toLowerCase();
export const productIndex = products => products instanceof Map ? products : new Map((products || []).filter(product => product?._id).map(product => [referenceId(product._id), product]));

export function validMappedProduct(item, organization, products) {
  if (!['COG', 'The Bengal Craft'].includes(organization)) return null;
  const product = productIndex(products).get(referenceId(item?.productId));
  // Archived identities remain historical mappings; only NEW selections require active=true.
  return product && product.organization === organization ? product : null;
}

export function mappingStatus(invoice, products, catalogReady = true) {
  const items = Array.isArray(invoice.items) ? invoice.items : [];
  if (!items.length || items.every(item => !item?.productId)) return 'Unmapped';
  if (!catalogReady) return 'Mapping unavailable';
  const index = productIndex(products);
  const count = items.filter(item => validMappedProduct(item, invoice.organization, index)).length;
  return count === items.length ? 'Mapped' : count ? 'Partially Mapped' : 'Unmapped';
}

export function matchesMapping(status, filter) {
  return filter === 'All' || (filter === 'Mapping Incomplete' ? status !== 'Mapped' : status === filter);
}
